import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { RoosterReels } from "../../core/reels/RoosterReels";


export class ReelComponent extends AbstractDisplayComponent {
    private container: RoosterReels;

    public override init() {
        super.init();
        this.container = new RoosterReels();
    }



    public getInstance(): RoosterReels {

        return this.container;

    }



    public override destroy(): void {

        this.container.destroy({ children: true });

    }

}

